import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import { setUserTypingMessage } from 'APP/model/group/groupModel';

interface IUserTypingPresenter {
  sendTimeout: ReturnType<typeof setTimeout> | null;
  send(): void;
  reset(): void;
}

const SEND_TIMEOUT = 1000;

export const useUserTyping = (groupId: string): IUserTypingPresenter => {
  const source = useAsObservableSource({ groupId });

  const presenter = useLocalStore<IUserTypingPresenter>(() => ({
    sendTimeout: null,

    send(): void {
      if (presenter.sendTimeout) {
        return;
      }

      presenter.sendTimeout = setTimeout(() => {
        setUserTypingMessage(source.groupId);
        presenter.reset();
      }, SEND_TIMEOUT);
    },

    reset(): void {
      if (presenter.sendTimeout) {
        clearTimeout(presenter.sendTimeout);
        presenter.sendTimeout = null;
      }
    },
  }));

  useEffect(() => {
    return () => presenter.reset();
  }, [groupId]);

  return presenter;
};
